/*
 *  LayoutHeader.tsx
 * This Component is used to manage menu functionality in a single header and we'll use it all over the project.
 */

import UserProfile from "./user-profile";
import styles from "./layout-header.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { useContext } from "react";
import { UserContext } from "../../context";
import { TContext } from "../../types/config";

type TProps = {
  onToggleSideBar: Function;
  sideBarStatus: boolean;
};

export default function LayoutHeader(props: TProps) {
  const context: TContext = useContext(UserContext);
  return (
    <div className={styles.header}>
      <div
        className={styles.menuIconToggle}
        onClick={() => props.onToggleSideBar()}
      >
        <FontAwesomeIcon icon={faBars} size="sm" />
      </div>

      <div className={styles.headerMenu}>
        <div className={styles.timezoneContainer}>
          <div className={styles.timezoneHeader}>
            <span className={styles.liveIndicator}></span>
            <span className={styles.timezoneTitle}>TIMEZONE</span>
          </div>
          <span className={styles.timezoneValue}>
            {context?.user?.timeZonePreference}
          </span>
        </div>
        <div className={styles.rightHeaderMenu}>
          <div className={styles.userProfileIcon}>
            <UserProfile />
          </div>
          <div className={styles.gearicon}></div>
        </div>
      </div>
    </div>
  );
}
